import PosthogService from '~/services/posthog/PosthogService';
import { toCandidatePositionProperties, type IConfirmCandidatePositionContext } from './types';

/**
 * Fires when an office clicks the "Decline" button on the Confirm Candidate page
 * Event: dental_portal:confirm_candidate:decline_clicked
 */
export function fireConfirmCandidateDeclineClicked(
  payload: IConfirmCandidatePositionContext,
): void {
  PosthogService.getInstance().track(
    'dental_portal:confirm_candidate:decline_clicked',
    toCandidatePositionProperties(payload),
  );
}
